import { render } from "./ChatGPT.vue?vue&type=template&id=3a160e41&scoped=true"
import script from "./ChatGPT.vue?vue&type=script&lang=js"
export * from "./ChatGPT.vue?vue&type=script&lang=js"

import "./ChatGPT.vue?vue&type=style&index=0&id=3a160e41&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/personal_projects/openai/python_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a160e41"]])

export default __exports__